type Props = {
  kicker: string;
  title: string;
  sub?: string;
  anchor?: string;
  more?: boolean;
};

export default function SectionHead({ kicker, title, sub, anchor, more }: Props) {
  return (
    <div className="mb-5 flex flex-col gap-3 md:mb-7 md:flex-row md:items-end md:justify-between">
      <div>
        <div className="mb-2 inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1 text-xs font-medium tracking-wider text-foreground-600">
          <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
          {kicker}
        </div>
        <h2 className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {sub && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{sub}</p>}
      </div>
      {more && anchor && (
        <a
          href={anchor}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-background-200 px-4 py-2 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          查看全部
          <i className="ri-arrow-right-line text-sm" />
        </a>
      )}
    </div>
  );
}